export enum PermissionEntityType {
  General = "General",
  Permissions = "Permissions",
  ActionModules = "ActionModules",
  ServiceModules = "ServiceModules",
  ShopModules = "ShopModules",
  Groups = "Groups",
  Employees = "Employees",
  CompanyManagementUsers = "CompanyManagementUsers",
  SubCompanies = "SubCompanies"
}

export interface Permission {
  permissionName: string;
  entityType: PermissionEntityType;
  targetEntityId: number | null;
}